import React from 'react';
import graph from './graph';

import { toast } from 'react-toastify';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { UserCategoryModel } from 'models';
import { useMutation } from '@apollo/client';
import { isEmptyObject } from 'helpers/formatObject';

export default function AssignUserCategory({ id, active, refetch }) {
  const { userToken } = useSelector((state) => state.auth);

  const [assignment, { loading }] = useMutation(graph.assignment.query, {
    context: {
      serviceName: graph.assignment.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onAssign = async (selected, onClose) => {
    try {
      const { data, errors } = await assignment({
        variables: {
          coupon_id: id,
          send_sms: ['FOR_SET_COUPON'],
          user_category_id: selected[0]?.id,
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.assignment.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {}
  };

  return (
    <>
      <UserCategoryModel
        isPopup
        isAssign
        disabled={loading}
        onAssign={onAssign}
        assigning={loading}
        title="اختصاص گروه"
        action={
          <Button
            fullWidth
            size="medium"
            color="info"
            variant={active ? 'contained' : 'text'}
            sx={{ bgcolor: !active && 'info.lighter', color: 'info.dark' }}
          >
            اختصاص گروه
          </Button>
        }
      />
    </>
  );
}
